import React from 'react'
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';

  
function ProjectItem() {
  return (
    <Card
      sx={{
        minWidth: 275,
        height: '100%',
        borderRadius: '18px',
        border: '1px solid #e2e8f0',
        boxShadow: '0 10px 26px rgba(15, 23, 42, 0.06)',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: '0 18px 36px rgba(15, 23, 42, 0.1)',
        },
      }}
    >
      <CardContent sx={{ p: 2.4 }}>
        <Stack direction="row" spacing={1} sx={{ mb: 1.2 }}>
          <Chip label="React" size="small" sx={{ backgroundColor: '#eef2ff', color: '#4338ca', fontWeight: 700 }} />
          <Chip label="MUI" size="small" sx={{ backgroundColor: '#f8fafc', color: '#475569', fontWeight: 700 }} />
        </Stack>



        <Typography variant="h5" component="h3" sx={{ color: '#0f172a', fontWeight: 800, mb: 1 }}>
          Compitino
        </Typography>

        <Typography sx={{ color: '#475569', lineHeight: 1.75 }}>
          Personal knowledge base
        </Typography>
      </CardContent>

      <CardActions sx={{ px: 2.4, pb: 2.2, pt: 0 }}>
        <Button
          variant="outlined"
          size="small"
          component="a"
          href="https://compitino.com/"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            textTransform: 'none',
            borderRadius: '999px',
            borderColor: '#cbd5e1',
            color: '#0f172a',
            fontWeight: 600,
            px: 1.6,
          }}
        >
          View project
        </Button>
      </CardActions>

      <Box sx={{ px: 2.4, pb: 2.2, color: '#94a3b8', fontSize: '0.78rem' }}>Updated: May 2026</Box>
    </Card>

  )
}

export default ProjectItem